import type { ClientMetricsData } from '../../../services/metricsApi';
import { FormattedDateTime } from '../../common/FormattedDateTime';

export const ResultsPanel = ({
    data,
    panelType,
}: {
    data: ClientMetricsData[];
    panelType:
        | 'successfulAuthentication'
        | 'outdatedSuccessfulAuthentication'
        | 'failedAuthentication'
        | 'outdatedFailedAuthentication'
        | 'other';
}) => {
    let title: string;
    let panelStyle: string;
    let showAmount = true;
    switch (panelType) {
        case 'successfulAuthentication':
            title = 'Successful authentication requests';
            panelStyle = 'success';
            break;
        case 'outdatedSuccessfulAuthentication':
            title = 'Outdated successful authentication requests (results older than seven days)';
            panelStyle = 'warning';
            // Do not show since the provided value is misleading
            showAmount = false;
            break;
        case 'failedAuthentication':
            title = 'Failed authentication requests';
            panelStyle = 'danger';
            break;
        case 'outdatedFailedAuthentication':
            title = 'Outdated failed authentication requests (results older than seven days)';
            panelStyle = 'danger';
            // Do not show since the provided value is misleading
            showAmount = false;
            break;
        case 'other':
            title = 'Other';
            panelStyle = 'warning';
    }
    return (
        <div className={'row margin-bottom-20'}>
            <div className={'col-xs-4'}>
                <div className={`panel panel-${panelStyle}`}>
                    <div className='panel-heading'>{title}</div>
                    <div className='panel-body'>
                        {data.map((it, idx) => (
                            // biome-ignore lint/suspicious/noArrayIndexKey: suppressed out of convenience for migration to biomejs
                            <DataPanel data={it} showAmount={showAmount} key={idx} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

const DataPanel = ({ data, showAmount }: { data: ClientMetricsData; showAmount: boolean }) => (
    <div className='panel panel-default'>
        <div className='panel-body'>
            <div>
                <span>Status code: </span>
                <span>{data.statusCode}</span>
            </div>
            <div>
                <span>Last occurrence (before last execution): </span>
                <FormattedDateTime value={data.lastSeen} />
            </div>
            {showAmount && (
                <div>
                    <span>Number of occurrences (last week): </span>
                    <span>{data.amount}</span>
                </div>
            )}
        </div>
    </div>
);
